import http from "../../helpers/http";

import {
    FETCH_SERVICES_CONTENT,
    FETCH_SERVICES_CONTENT_SUCCESS,
    FETCH_SERVICES_CONTENT_FAILED
} from "./actionTypes";

export const fetchServices = () => (dispatch) => {
    dispatch({
        type: FETCH_SERVICES_CONTENT,
        payload: null
    });
    http
        .get("services-page")
        .then(({ data }) => {
            dispatch({
                type: FETCH_SERVICES_CONTENT_SUCCESS,
                payload: data
            });
        })
        .catch((error) => {
            dispatch({
                type: FETCH_SERVICES_CONTENT_FAILED,
                payload: error
            });
        });
};
